import React from 'react';
import './App.css'; // Importujemy styl CSS dla stopki

const Footer = () => {
  return (
    <footer className="Footer">
    
      <div className="FooterBottom">
        <p>&copy; 2024 Przemysław Sikora. Wszelkie prawa zastrzeżone.</p>
      </div>
    </footer>
  );
}

export default Footer;
